/**
 * 图片URL处理工具函数
 * 支持多种图片URL格式，确保在UI中正确显示
 * 
 * @param {string} url - 原始图片URL
 * @param {string} [fallbackUrl='/images/default-event-image.jpg'] - 失败时的默认图片URL
 * @returns {string} 处理后的图片URL
 */
const getDirectImageUrl = (url, fallbackUrl = '/images/default-event-image.jpg') => {
  if (!url) return fallbackUrl;

  try {
    // Cloudinary URL处理
    if (url.includes('cloudinary.com')) {
      return url;
    }

    // AWS S3和CloudFront URL处理
    if (url.includes('amazonaws.com') || url.includes('cloudfront.net')) {
      return url;
    }

    // 处理Google Drive URL
    if (url.includes('drive.google.com')) {
      let fileId;
      
      // 提取不同格式的Google Drive文件ID
      if (url.includes('/file/d/')) {
        fileId = url.split('/file/d/')[1].split('/')[0];
      } else if (url.includes('id=')) {
        const match = url.match(/id=([^&]+)/);
        if (!match) {
          console.warn('无法从Google Drive URL提取文件ID:', url);
          return fallbackUrl;
        }
        fileId = match[1];
      }

      if (!fileId) {
        console.warn('无法从Google Drive URL提取文件ID:', url);
        return fallbackUrl;
      }

      // 使用更可靠的缩略图URL格式
      return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
    }

    // 处理相对URL
    if (url.startsWith('./')) {
      url = url.substring(1);
    } else if (!url.startsWith('http') && !url.startsWith('/')) {
      // 确保相对URL以/开头
      url = '/' + url;
    }
    
    // 处理数据URL (例如来自FileReader)
    if (url.startsWith('data:')) {
      return url;
    }
    
    // 如果没有特殊处理，返回原URL
    return url;
  } catch (error) {
    console.warn('处理图片URL时出错:', error, '使用默认图片。');
    return fallbackUrl;
  }
};

export default getDirectImageUrl;